import React from "react";

import { motion } from "framer-motion";

export type ExpandableSidebarProps = {
  tabs?: any;
  isExpanded: boolean;
  collapseTabs?: boolean;
  children?: React.ReactNode;
};

export const ExpandableSidebar = ({
  tabs,
  isExpanded,
  collapseTabs = false,
  children
}: ExpandableSidebarProps) => {
  const containerClasses = [
    "ExpandableSidebar",
    `ExpandableSidebar--${isExpanded ? "expanded" : "collapsed"}`,
    "flex flex-row flex-nowrap justify-start content-stretch items-start",
    "h-full pb-[var(--safe-area-inset-bottom,0px)]",
    "bg-panel-background rounded-tl-lg",
    !isExpanded && "opacity-0"
  ]
    .filter(Boolean)
    .join(" ");

  const menuClasses = [
    "ExpandableSidebar__menu",
    "ExpandableSidebar__menu--vertical",
    "flex-[0_1_80px] w-[72px] self-stretch",
    "border-r-panel border-r-border-color"
  ].join(" ");

  const contentClasses = [
    "ExpandableSidebar__content",
    "flex-[1_0_auto] self-stretch opacity-100",
    "w-sidebar h-full"
  ].join(" ");

  return (
    <div className={containerClasses}>
      {collapseTabs && tabs ? <div className={menuClasses}>{tabs}</div> : ""}
      <motion.div
        animate={isExpanded ? "open" : "closed"}
        transition={{ duration: 0.25, type: "tween", delay: 0 }}
        variants={{
          open: { opacity: 1, width: "auto", height: "100%", x: 0 },
          closed: { opacity: 1, width: "0", height: "100%", x: -332 }
        }}
      >
        {!collapseTabs && tabs ? <div className={menuClasses}>{tabs}</div> : ""}

        <div className={contentClasses}>{children}</div>
      </motion.div>
    </div>
  );
};
